export default {"src":"/_next/static/media/ram.00d996c2.svg","height":24,"width":24};